import React from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';

// type Props = {
//     resultValue: number
// }

const ResultComponent = ({ resultValue }) => { //트리노드 결과 값 별 페이지 출력
    const cdnUrl = useRecoilValue(cdnUrlConfig);
    const IMG_URL = `${cdnUrl}/BigglzEvent`;

    function getView(result) {
        if (result === 36) { //ESTJ 포메라니안
            return (
                <>
                    <h2>
                        누구보다 당당하게!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_pome.png`} alt="위풍당당 포메라니안" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>포메라니안</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_01.png`} alt="mbti_260x260_01.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        태양보다 당당하고 자신감 넘치는 당신에게는 포메라니안이 어울려요. 포메라니안은 비록 작은 덩치를 가지고 있지만 어떤 상황에서도 자신감을 잃지 않고 당당하게 행동하는 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_01.png`} alt="mbti_item_208x208_01.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>모던룸 쇼파</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_02.png`} alt="mbti_item_208x208_02.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>모던룸 러그</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>러시안블루</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_16.png`} alt="mbti_260x260_16.png" />
                                    </figure>
                                </div>
                                <div className="name">온화한 <span>러시안블루</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>노르웨이숲</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_10.png`} alt="mbti_260x260_10.png" />
                                    </figure>
                                </div>
                                <div className="name">따뜻한 감성의 <span>노르웨이숲</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 37) { //ESFP 닥스훈트
            return (
                <>
                    <h2>
                        아무도 날 막지 못해!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_dachshund.png`} alt="mbti_tit_dachshund.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>닥스훈트</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_02.png`} alt="mbti_260x260_02.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        누구보다 자유로운 영혼으로 속박이 없는 당신은 닥스훈트와 어울려요. 닥스훈트는 주인에 대한 애정과 충성심은 물론 활발한 활동력을 가진 그야말로 분위기 메이커인 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>인디언룸 텐트</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_03.png`} alt="mbti_item_208x208_03.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>인디언룸 텐트</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>커튼이 쳐져있는 창문</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_04.png`} alt="mbti_item_208x208_04.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>커튼이 쳐져있는 창문</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>먼치킨</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_15.png`} alt="mbti_260x260_15.png" />
                                    </figure>
                                </div>
                                <div className="name">차분한<span>먼치킨</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>스핑크스</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_13.png`} alt="mbti_260x260_13.png" />
                                    </figure>
                                </div>
                                <div className="name">너그러운<span>스핑크스</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 38) { //ENTP 슈나우저
            return (
                <>
                    <h2>
                        하고 싶은게 너무 많아!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_schnauzer.png`} alt="mbti_tit_schnauzer.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>슈나우저</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_03.png`} alt="mbti_260x260_03.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        아는 것이 많고 다방면에 뛰어난 당신은 슈나우저와 어울려요. 수렵견 출신의 멋진 수염을 가진 슈나우저는 왕성한 에너지와 높은 지능으로 여러 사물에 호기심을 가지는 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_05.png`} alt="mbti_item_208x208_05.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>다비르의 탄생</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_06.png`} alt="mbti_item_208x208_06.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>체리향 향초</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>페르시안</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_14.png`} alt="mbti_260x260_14.png" />
                                    </figure>
                                </div>
                                <div className="name">섬세한 <span>페르시안</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>터키쉬 앙고라</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_09.png`} alt="mbti_260x260_09.png" />
                                    </figure>
                                </div>
                                <div className="name">영리한 <span>터키쉬 앙고라</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 39) { //ESTP 보더콜리
            return (
                <>
                    <h2>
                        뭐든지 다 잘하는 신동!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_bordercollie.png`} alt="mbti_tit_bordercollie.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>보더콜리</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_04.png`} alt="mbti_260x260_04.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        활발한 성격과 뛰어난 머리로 문제 해결을 하는 당신은 보더콜리와 어울려요. 보더콜리는 세계에서 머리가 좋은 견종으로 활발한 성격에 마르지 않은 체력을 가진 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption></figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_07.png`} alt="mbti_item_208x208_07.png" />
                                    </figure>
                                </div>
                                <div className="name">오이스터 <span>책더미</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption></figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_08.png`} alt="mbti_item_208x208_08.png" />
                                    </figure>
                                </div>
                                <div className="name">오이스터 <span>법랑 머그</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>스핑크스</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_13.png`} alt="mbti_260x260_13.png" />
                                    </figure>
                                </div>
                                <div className="name">너그러운 <span>스핑크스</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>먼치킨</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_15.png`} alt="mbti_260x260_15.png" />
                                    </figure>
                                </div>
                                <div className="name">호기심 많은 <span>먼치킨</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 40) { //ENFJ 푸들
            return (
                <>
                    <h2>
                        정이 너무 많아!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_poodle.png`} alt="mbti_tit_poodle.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>푸들</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_05.png`} alt="mbti_260x260_05.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        온화하고 동정심이 많으며, 공감 능력이 뛰어난 당신은 푸들과 어울려요. 푸들은 오랫동안 사람과 지내 뛰어난 상호작용으로 따뜻한 위로를 건넬 줄 아는 푸근한 성격의 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_09.png`} alt="mbti_item_208x208_09.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>노란꽃 호리병</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_10.png`} alt="mbti_item_208x208_10.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>엔틱한 가구</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>퍼그</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_12.png`} alt="mbti_260x260_12.png" />
                                    </figure>
                                </div>
                                <div className="name">맘대로 <span>퍼그</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>스코티시 폴드</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_11.png`} alt="mbti_260x260_11.png" />
                                    </figure>
                                </div>
                                <div className="name">멍 때리는 <span>스코티시 폴드</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 41) { //ESFJ 골든 리트리버
            return (
                <>
                    <h2>
                        내가 바로 친목왕!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_goldenretriever.png`} alt="mbti_tit_goldenretriever.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>골든 리트리버</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_06.png`} alt="mbti_260x260_06.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        어디서나 잘 어울리는 놀라운 친화력과 다른 사람에게 많은 관심을 가진 당신은 골든 리트리버와 어울려요. 큰 덩치를 가진 골든 리트리버는 누구에게나 상냥하고 친절한 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>도몽찌</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_11.png`} alt="mbti_item_208x208_11.png" />
                                    </figure>
                                </div>
                                <div className="name">도몽찌<span>베이비 인형 세트</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>도몽찌</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_12.png`} alt="mbti_item_208x208_12.png" />
                                    </figure>
                                </div>
                                <div className="name">도몽찌<span>장난감 블록 세트</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>스코티시 폴드</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_11.png`} alt="mbti_260x260_11.png" />
                                    </figure>
                                </div>
                                <div className="name">멍 때리는 <span>스코티시 폴드</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>퍼그</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_12.png`} alt="mbti_260x260_12.png" />
                                    </figure>
                                </div>
                                <div className="name">맘대로 <span>퍼그</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 42) { //ENFP 비글
            return (
                <>
                    <h2>
                        한시라도 가만있지 못해!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_beagle.png`} alt="mbti_tit_beagle.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>비글</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_07.png`} alt="mbti_260x260_07.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        지치지 않는 정렬과 활기를 가진 비글미 넘치는 당신은 비글이 어울려요. 에너지의 대명사인 비글은 누구보다 활발한 활동량으로 비글미라는 신조어를 만들어 낼 정도로 발랄한 강아지랍니다
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>미야오닷컴</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_13.png`} alt="mbti_item_208x208_13.png" />
                                    </figure>
                                </div>
                                <div className="name">미야오닷컴 <span> 우산 쓴 코코넛 </span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>미야오타운</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_14.png`} alt="mbti_item_208x208_14.png" />
                                    </figure>
                                </div>
                                <div className="name">미야오닷컴 <span> 빨간 꽃 </span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>터키쉬 앙고라</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_09.png`} alt="mbti_260x260_09.png" />
                                    </figure>
                                </div>
                                <div className="name">영리한 <span>터키쉬 앙고라</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>페르시안</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_14.png`} alt="mbti_260x260_14.png" />
                                    </figure>
                                </div>
                                <div className="name">섬세한 <span>페르시안</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 43) { //ENTJ 도베르만
            return (
                <>
                    <h2>
                        타고난 카리스마!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_doberman.png`} alt="mbti_tit_doberman.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>도베르만</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_08.png`} alt="mbti_260x260_08.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        강렬한 카리스마와 타고난 리더쉽으로 누구보다 앞장서는 당신은 도베르만이 어울려요. 탄탄한 근육질의 외모가 돋보이는 도베르만은 굳은 의지와 행동력을 지니고 있는 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_15.png`} alt="mbti_item_208x208_15.png" />
                                    </figure>
                                </div>
                                <div className="name">킴밍스튜디오 <span>조명</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>킴밍스튜디오</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_16.png`} alt="mbti_item_208x208_16.png" />
                                    </figure>
                                </div>
                                <div className="name">킴밍스튜디오 <span>포스터 액자</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>노르웨이숲</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_10.png`} alt="mbti_260x260_10.png" />
                                    </figure>
                                </div>
                                <div className="name">따뜻한 감성의 <span>노르웨이숲</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>러시안 블루</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_16.png`} alt="mbti_260x260_16.png" />
                                    </figure>
                                </div>
                                <div className="name">온화한 <span>러시안 블루</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 44) { //ISTJ 터키쉬 앙고라
            return (
                <>
                    <h2>
                        내 속에 생각 너무 많아!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_turkishangora.png`} alt="mbti_tit_turkishangora.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>터키쉬 앙고라</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_09.png`} alt="mbti_260x260_09.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        체계적이고 집중력이 강하고 신중한 당신은 터키쉬 앙고라와 어울려요. 터키쉬 앙고라는 우아하고, 스킨쉽을 싫어하는 까칠한 면도 있지만 사물에 관심이 많고 영리한 고양이랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>MMUMIQ</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_17.png`} alt="mbti_item_208x208_17.png" />
                                    </figure>
                                </div>
                                <div className="name">MMUMIQ <span> 편안한 쇼파 </span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>MMUMIQ</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_18.png`} alt="mbti_item_208x208_18.png" />
                                    </figure>
                                </div>
                                <div className="name">MMUMIQ <span>키치한 어항</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>비글</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_07.png`} alt="mbti_260x260_07.png" />
                                    </figure>
                                </div>
                                <div className="name">재기발랄<span>비글</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>슈나우저</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_03.png`} alt="mbti_260x260_03.png" />
                                    </figure>
                                </div>
                                <div className="name">팔방미인<span>슈나우저</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 45) { //ISFP 노르웨이숲
            return (
                <>
                    <h2>
                        과묵하지만 다정한!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_norwegianforest.png`} alt="mbti_tit_norwegianforest.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>노르웨이숲</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_10.png`} alt="mbti_260x260_10.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        말없이 다정하고 온화하지만 내면의 모습을 잘 보이지 않는 당신은 노르웨이 숲과 어울려요. 노르웨이 숲은 평소에 조용하고 우아한 성격이지만, 사람을 매우 좋아해 애교가 많은 고양이랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg콜렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_19.png`} alt="mbti_item_208x208_19.png" />
                                    </figure>
                                </div>
                                <div className="name">gg콜렉션 <span>털실</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg콜렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_20.png`} alt="mbti_item_208x208_20.png" />
                                    </figure>
                                </div>
                                <div className="name">gg콜렉션<span>장식 벽난로</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>도베르만</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_08.png`} alt="mbti_260x260_08.png" />
                                    </figure>
                                </div>
                                <div className="name">무리의 지도자<span>도베르만</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>포메라니안</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_01.png`} alt="mbti_260x260_01.png" />
                                    </figure>
                                </div>
                                <div className="name">위풍당당<span>포메라니안</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 46) { //INTP 스코티시 폴드
            return (
                <>
                    <h2>
                        머릿속에 펼쳐진 우주!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_scottishfold.png`} alt="mbti_tit_scottishfold.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>스코티시 폴드</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_11.png`} alt="mbti_260x260_11.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        조용하고 논리적이나 몽상가인 당신은 스코티시 폴드와 어울려요. 스코티시 폴드는 성격이 전체적으로 차분하고 울음소리도 작은 조용한 성격이지만, 주인에게는 애교가 폭발하는 귀여운 고양이랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>yooziny</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_21.png`} alt="mbti_item_208x208_21.png" />
                                    </figure>
                                </div>
                                <div className="name">yooziny <span>순대의 우주선</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>yooziny</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_22.png`} alt="mbti_item_208x208_22.png" />
                                    </figure>
                                </div>
                                <div className="name">yooziny <span>순대의 우주 창문</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>골든 리트리버</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_06.png`} alt="mbti_260x260_06.png" />
                                    </figure>
                                </div>
                                <div className="name">핵인싸<span>골든 리트리버</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>푸들</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_05.png`} alt="mbti_260x260_05.png" />
                                    </figure>
                                </div>
                                <div className="name">다정다감<span>푸들</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 47) { //ISTP 퍼그
            return (
                <>
                    <h2>
                        느긋하지만 고집쟁이
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_pug.png`} alt="mbti_tit_pug.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>퍼그</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_12.png`} alt="mbti_260x260_12.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        주변에 좌지우지되지 않고 자신의 일을 진행하는 당신은 퍼그와 어울려요. 퍼그는 느긋하고 순한 반면 자신만의 고집이 있어서 주관대로 행동하려는 경향이 강한 강아지랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>미야오타운</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_23.png`} alt="mbti_item_208x208_23.png" />
                                    </figure>
                                </div>
                                <div className="name">미야오타운 <span>다락방 카펫</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>미야오타운</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_24.png`} alt="mbti_item_208x208_24.png" />
                                    </figure>
                                </div>
                                <div className="name">미야오타운 <span>블루 소파</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>푸들</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_05.png`} alt="mbti_260x260_05.png" />
                                    </figure>
                                </div>
                                <div className="name">다정다감<span>푸들</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>골든 리트리버</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_06.png`} alt="mbti_260x260_06.png" />
                                    </figure>
                                </div>
                                <div className="name">핵인싸<span>골든 리트리버</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 48) { //INFJ 스핑크스
            return (
                <>
                    <h2>
                        난 관대하다!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_sphinx.png`} alt="mbti_tit_sphinx.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>스핑크스</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_13.png`} alt="mbti_260x260_13.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        화합을 추구하고, 성숙한 정신과 인내심을 지닌 당신은 스핑크스와 어울려요. 차분하고 점잖은 스핑크스는 의외로 높은 친화력을 지니고 있어 많은 사람들의 사랑을 받는 고양이랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>Oiguclub</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_25.png`} alt="mbti_item_208x208_25.png" />
                                    </figure>
                                </div>
                                <div className="name">Oiguclub <span>미니 치즈 소파</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>Oiguclub</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_26.png`} alt="mbti_item_208x208_26.png" />
                                    </figure>
                                </div>
                                <div className="name">Oiguclub <span>버터 러그</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>보더콜리</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_04.png`} alt="mbti_260x260_04.png" />
                                    </figure>
                                </div>
                                <div className="name">다재다능<span>보더콜리</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>닥스훈트</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_02.png`} alt="mbti_260x260_02.png" />
                                    </figure>
                                </div>
                                <div className="name">자유로운<span>닥스훈트</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 49) { //ISFJ 페르시안
            return (
                <>
                    <h2>
                        부드럽게 다루어주세용!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_persian.png`} alt="mbti_tit_persian.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>페르시안</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_14.png`} alt="mbti_260x260_14.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        섬세한 배려로 주변을 따뜻하게 돌보는 당신은 페르시안과 어울려요. 페르시안은 독립적인 성격으로 혼자 보내는 시간도 좋아하지만 주인과 함께 있는 시간은 더 좋아하는 차분하고 따뜻한 고양이랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>르미보리</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_27.png`} alt="mbti_item_208x208_27.png" />
                                    </figure>
                                </div>
                                <div className="name">르미보리 <span>보리의 백드롭</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>르미보리</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_28.png`} alt="mbti_item_208x208_28.png" />
                                    </figure>
                                </div>
                                <div className="name">르미보리 <span>보리의 거울</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>슈나우저</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_03.png`} alt="mbti_260x260_03.png" />
                                    </figure>
                                </div>
                                <div className="name">팔방미인<span>슈나우저</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>비글</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_07.png`} alt="mbti_260x260_07.png" />
                                    </figure>
                                </div>
                                <div className="name">재기발랄<span>비글</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 50) { //INTJ 먼치킨
            return (
                <>
                    <h2>
                        재밌는게 잔뜩 있어!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_munchkin.png`} alt="mbti_tit_munchkin.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>먼치킨</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_15.png`} alt="mbti_260x260_15.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        타고난 사고력으로 하고자 하는 바를 이뤄내는 당신은 먼치킨과 어울려요. 활발하고 사교적인 성격으로도 유명한 먼치킨은 처음 보는 사물에 끝없는 관심을 주는 왕성한 호기심을 가진 고양이랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_29.png`} alt="mbti_item_208x208_29.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션<span>검은고양이 러그</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>gg컬렉션</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_30.png`} alt="mbti_item_208x208_30.png" />
                                    </figure>
                                </div>
                                <div className="name">gg컬렉션 <span>장난감 쥐</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>닥스훈트</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_02.png`} alt="mbti_260x260_02.png" />
                                    </figure>
                                </div>
                                <div className="name">자유로운<span>닥스훈트</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>보더콜리</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_04.png`} alt="mbti_260x260_04.png" />
                                    </figure>
                                </div>
                                <div className="name">다재다능<span>보더콜리</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else if (result === 51) { //INFP 러시안 블루
            return (
                <>
                    <h2>
                        훈훈 그 자체!
                        <strong className="on">
                            <img src={`${IMG_URL}/images/mbti/img/mbti_tit_russianblue.png`} alt="mbti_tit_russianblue.png" />
                        </strong>
                    </h2>
                    <div className="img-result">
                        <figure>
                            <figcaption>러시안 블루</figcaption>
                            <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_16.png`} alt="mbti_260x260_16.png" />
                        </figure>
                    </div>
                    <div className="txt">
                        차분하지만 낭만적인 성향인 당신은 러시안 블루와 어울려요. 러시안 블루는 온순하고 조용한 성격이지만 내 가족에게는 깊은 애정을 가지고 있는 따뜻한 고양이랍니다.
                    </div>
                    <div className="sub">
                        <h3>추천가구</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>뽀야랜드</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_31.png`} alt="mbti_item_208x208_31.png" />
                                    </figure>
                                </div>
                                <div className="name">뽀야랜드<span>뽀야캐쳐</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>뽀야랜드</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_item_208x208_32.png`} alt="mbti_item_208x208_32.png" />
                                    </figure>
                                </div>
                                <div className="name">뽀야랜드<span>뽀드등</span></div>
                            </li>
                        </ul>
                    </div>
                    <div className="sub">
                        <h3>환상의 짝꿍</h3>
                        <ul>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>포메라니안</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_01.png`} alt="mbti_260x260_01.png" />
                                    </figure>
                                </div>
                                <div className="name">위풍당당<span>포메라니안</span></div>
                            </li>
                            <li>
                                <div className="img">
                                    <figure>
                                        <figcaption>먼치킨</figcaption>
                                        <img src={`${IMG_URL}/images/mbti/img/mbti_260x260_15.png`} alt="mbti_260x260_15.png" />
                                    </figure>
                                </div>
                                <div className="name">호기심 많은<span>먼치킨</span></div>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
        else {
            return (
                <>
                    <h2>
                        <strong>잘못된 접근입니다</strong>
                        Not Found 404
                    </h2>
                    <div className="img-result">
                    </div>
                    <div className="txt">
                    </div>
                    <div className="sub">
                    </div>
                    <div className="sub">
                    </div>
                </>
            )
        }
    }

    return (
        <>{getView(resultValue)}</>
    )
}

export default ResultComponent